import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";
import { TextSection } from "containers/Manual/components/section/TextSection";
import { ImgRoute } from "contents/Images";

export const CONCATENATE = () => {
  return (
    <CardSection id="CONCATENATE" title="CONCATENATE">
      <TextSection>
        + 연산자를 사용하여 텍스트를 결합합니다. 하이픈으로 두 열을 결합하려면
        <br />
        <Paragraph accent inline>
          `Last` + "-" + `First`
        </Paragraph>
        일련의 텍스트 문자열을 단일 텍스트 문자열로 결합합니다.
      </TextSection>
      <TextSection>
        또는 <b>CONCATENATE</b> 함수를 사용합니다.
        <Paragraph accent inline>
          CONCATENATE(`Last`, "-", `First`)
        </Paragraph>
      </TextSection>

      <ListSection title="Syntax">
        <Paragraph accent>CONCATENATE(STRING_1, [STRING_2, ...])</Paragraph>
        <Ul>
          <Li>
            <b>STRING_1</b>은 첫 번째 값입니다.
          </Li>
          <Li>
            <b>STRING_2, ... [선택 사항]</b>은 추가 문자열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>
          CONCATENATE(`Applicant Last`, ", ", `Applicant First`, " of ", `City`)
        </Paragraph>
        <Img src="computeConcatenate" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>STRING</b>은 텍스트 문자열이나 숫자 값이 될 수 있으며,
          텍스트 문자열이나 숫자 값이 포함된 열이거나, 텍스트 문자열이나 숫자
          값을 반환하는 함수일 수 있습니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
